module.exports = __webpack_public_path__ + "static/assets/540b95a1842bb865b50e03b337af311d.png";